import {
    gql,
    useQuery
} from "@apollo/client";
import {
    FindUserPointExchangeHistoryByIdQueryQuery,
    FindUserPointExchangeHistoryByIdQueryQueryVariables
} from "../../../../schemaTypes";

export const findUserPointExchangeHistoryByIdQuery = gql`
  query FindUserPointExchangeHistoryByIdQuery($id: String!) {
    findUserPointExchangeHistoryById(id: $id) {
      id
      communityId
      communityName
      point
      rate
      exchangedPoint
      createdAt
    }
  }
`;

export const useFindUserPointExchangeHistoryById = (id: string) => {
  const { data, loading, error, refetch } = useQuery<
    FindUserPointExchangeHistoryByIdQueryQuery,
    FindUserPointExchangeHistoryByIdQueryQueryVariables
  >(findUserPointExchangeHistoryByIdQuery, {
    variables: { id },
    skip: !id,
  });

  return {
    data: data?.findUserPointExchangeHistoryById || null,
    loading,
    error,
    refetch,
  };
};
